import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
var actionButtonDict = {
  0: {
    consultant: 'Log time',
    employer: 'Time track'
  },
  1: {
    consultant: 'Submit',
    employer: 'Approve'
  },
  2: {
    consultant: 'Export',
    employer: 'Invite'
  },
  3: {
    consultant: 'Ready',
    employer: 'Ready'
  }
};
var progressEllipses = function progressEllipses(sequence, setSequence) {
  var elements = [];
  var _loop = function _loop(i) {
    elements.push(/*#__PURE__*/React.createElement("i", {
      key: i,
      className: "".concat(sequence === i ? 'fas' : 'far', " fa-circle"),
      role: "link",
      tabIndex: 0,
      onClick: function onClick() {
        return setSequence(i);
      }
    }));
  };
  for (var i = 0; i < 4; i += 1) {
    _loop(i);
  }
  return elements;
};
var renderForwardStep = function renderForwardStep(type, sequence) {
  return actionButtonDict[sequence][type];
};
function InvoicesWalkthroughFooter(_ref) {
  var type = _ref.type,
    sequence = _ref.sequence,
    setSequence = _ref.setSequence,
    closeModal = _ref.closeModal;
  return /*#__PURE__*/React.createElement("div", {
    className: "walthrough-footer"
  }, /*#__PURE__*/React.createElement("span", {
    className: "backward",
    tabIndex: 0,
    role: "link",
    onClick: function onClick() {
      if (sequence > 0) setSequence(sequence - 1);
    }
  }, sequence > 0 && /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement("i", {
    className: "fas fa-angle-left"
  }), "Back")), /*#__PURE__*/React.createElement("span", {
    className: "progress-ellipses"
  }, progressEllipses(sequence, setSequence)), /*#__PURE__*/React.createElement("span", {
    className: "forward",
    tabIndex: 0,
    role: "link",
    onClick: function onClick() {
      if (sequence === 3) closeModal();
      setSequence(sequence < 3 ? sequence + 1 : 0);
    }
  }, renderForwardStep(type, sequence), /*#__PURE__*/React.createElement("i", {
    className: "fas fa-angle-right"
  })));
}
InvoicesWalkthroughFooter.propTypes = {
  type: PropTypes.string.isRequired,
  sequence: PropTypes.number.isRequired,
  setSequence: PropTypes.func.isRequired,
  closeModal: PropTypes.func.isRequired
};
export default InvoicesWalkthroughFooter;